import { Chess, type Square } from 'chess.js';

/** Petits utilitaires chess.js partagés par les composants d'échiquier interactifs. */

export interface LegalTarget {
  to: string;
  promotion?: string;
  isCapture: boolean;
}

export function getLegalTargets(fen: string, from: string): LegalTarget[] {
  try {
    const chess = new Chess(fen);
    const moves = chess.moves({ square: from as Square, verbose: true });
    return moves.map((m) => ({ to: m.to, promotion: m.promotion, isCapture: Boolean(m.captured) }));
  } catch {
    return [];
  }
}

export function pieceAt(fen: string, square: string): { type: string; color: 'w' | 'b' } | null {
  try {
    const chess = new Chess(fen);
    return chess.get(square as Square) || null;
  } catch {
    return null;
  }
}

export function sideToMove(fen: string): 'w' | 'b' {
  return fen.split(' ')[1] === 'b' ? 'b' : 'w';
}

export function needsPromotionChoice(fen: string, from: string, to: string): boolean {
  const targets = getLegalTargets(fen, from);
  return targets.some((t) => t.to === to && t.promotion);
}

export function toUci(from: string, to: string, promotion?: string): string {
  return promotion ? `${from}${to}${promotion}` : `${from}${to}`;
}

/** Normalise la casse de la promotion ("e7e8Q" vs "e7e8q") pour comparer deux UCI. */
export function normalizeUci(uci: string): string {
  return uci.length > 4 ? uci.slice(0, 4) + uci.slice(4).toLowerCase() : uci;
}
